import CryptoJS from 'crypto-js'
import pako from 'pako'
import _ from 'lodash'

const aesKey = '7hhGCjJ8LdQRbQ7oPo3mwg=='

class CryptoUtils {
  /**
   * 解压 GZIP 后的 Base64 数据
   */
  ungzip(base64Data: string): string {
    try {
      // 在浏览器环境下，atob 是原生的
      const strData = atob(base64Data)
      const charData = strData.split('').map((x) => x.charCodeAt(0))
      const binData = new Uint8Array(charData)
      const data = pako.inflate(binData, { to: 'string' })
      return this.byteToString(data)
    } catch (e) {
      console.error('ungzip error:', e)
      return base64Data
    }
  }

  /**
   * 二进制转成字符串（解决解压时中文乱码的情况）
   */
  private byteToString = (arr: any): string => {
    if (typeof arr === 'string') {
      return arr
    }
    let str = ''
    const _arr = arr
    for (let i = 0; i < _arr.length; i++) {
      const one = _arr[i].toString(2)
      const v = one.match(/^1+?(?=0)/)
      if (v && one.length === 8) {
        const bytesLength = v[0].length
        let store = _arr[i].toString(2).slice(7 - bytesLength)
        for (let st = 1; st < bytesLength; st++) {
          store += _arr[st + i].toString(2).slice(2)
        }
        str += String.fromCharCode(parseInt(store, 2))
        i += bytesLength - 1
      } else {
        str += String.fromCharCode(_arr[i])
      }
    }
    return str
  }

  /**
   * AES 加密
   */
  encryptAes = (jsonData: any): string => {
    const aesIv = 'EWDrrwH4wRDTCCywbGlBlA=='
    const iv = CryptoJS.enc.Base64.parse(aesIv)
    const key = CryptoJS.enc.Base64.parse(aesKey)
    const text = JSON.stringify(jsonData)
    const cipher = CryptoJS.AES.encrypt(text, key, { iv })
    const str = CryptoJS.enc.Base64.stringify(cipher.ciphertext)
    const value = `${aesIv}:${str}`
    return value
  }

  /**
   * AES 解密
   */
  decryptAes = (strData: string): any => {
    if (!strData || typeof strData !== 'string') return strData
    
    const items = strData.split(':')
    if (items.length !== 2) {
      return strData
    }
    
    try {
      const iv = CryptoJS.enc.Base64.parse(items[0])
      const key = CryptoJS.enc.Base64.parse(aesKey)
      const ciphertext = CryptoJS.AES.decrypt(items[1], key, { iv })
      const str = CryptoJS.enc.Base64.stringify(ciphertext)
      
      const unzipped = this.ungzip(str)
      return this.safeJsonParse(unzipped)
    } catch (e) {
      console.error('decryptAes error:', e)
      return strData
    }
  }

  /**
   * 安全解析 JSON
   */
  private safeJsonParse(jsonStr: string): any {
    if (_.isString(jsonStr)) {
      try {
        return JSON.parse(jsonStr)
      } catch (e) {
        console.warn('JSON parse error = ' + e)
      }
    } else if (_.isObject(jsonStr)) {
      return jsonStr
    }
    return null
  }
}

export default new CryptoUtils()
